var _g, _path, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalCreateHyprFlows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_185_4213)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 150,
    height: 150,
    rx: 38,
    stroke: "url(#paint0_linear_185_4213)",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_185_4213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 40,
    width: 72,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 40H40V112H112V40Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_185_4213)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_185_4213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.5266 52.2439H67.163V68.6075H83.5266V52.2439Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3636 85.8181H40V102.182H56.3636V85.8181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5454 85.8181H66.1818V102.182H82.5454V85.8181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.727 85.8181H92.3636V102.182H108.727V85.8181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.424 79.2398C107.935 79.6866 108.155 80.4297 108.098 81.5123L109.471 81.5837C109.552 80.053 109.177 78.9484 108.329 78.206C106.291 76.4208 102.014 77.2244 95.5375 78.4383C90.1427 79.4508 83.4944 80.6737 75.9489 80.8249V68.0547H74.5742V80.8249C67.028 80.6737 60.3811 79.4508 54.9865 78.4383C48.512 77.2237 44.233 76.4208 42.1943 78.206C41.346 78.9484 40.9721 80.0537 41.0525 81.5837L42.4259 81.5123C42.3689 80.4303 42.5888 79.6873 43.0996 79.2398C44.6352 77.896 49.0908 78.7318 54.7329 79.7904C60.1577 80.807 66.8335 82.0429 74.4525 82.2038V82.2354C74.7267 82.2354 74.9901 82.2217 75.2616 82.2196C75.5337 82.2223 75.7971 82.2354 76.0713 82.2354V82.2038C83.6903 82.0436 90.3668 80.8077 95.7908 79.7904C101.432 78.7318 105.888 77.896 107.424 79.2398Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_185_4213",
    x: -24,
    y: -24,
    width: 200,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_185_4213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_185_4213",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_185_4213",
    x: 40,
    y: 52.2439,
    width: 69.4821,
    height: 53.9377,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_185_4213"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_185_4213",
    x1: 76,
    y1: 1,
    x2: 76,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalCreateHyprFlows);
export default __webpack_public_path__ + "static/media/Goal-Create-HyprFlows.d0cc0af7baf9972fa259c637a6e33967.svg";
export { ForwardRef as ReactComponent };